import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';
import utils from '../../../lib/utils';

export default class ZenotiReferral extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      referralEmail: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    this.props.getBookingSoftwareLocations();
    const { softwares } = this.props;
    const { zenotiData, form } = softwares;
    console.log('STATE 1234', form)
    this.setState({
      ...(zenotiData.referralEmail || form?.referral_email&& {referralEmail:zenotiData.referralEmail?zenotiData.referralEmail:form.referral_email}),
    });
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { referralEmail,mandatoryFieldError } = this.state;
    const data ={ referralEmail };
    const validationResult = this.validate(data);
    console.log('data',validationResult,mandatoryFieldError)
    if (validationResult) {
      this.props.saveReferral(data);
      this.props.storeZentiData(data);
    }
  }

  validate(data) {
    console.log('data',data);
    if (!data.referralEmail || !utils.isValidEmail(data.referralEmail)) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { referralEmail , mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter referral email</p>
            <input
              type="text"
              name="referralEmail"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={referralEmail}
              onChange={this.onInputChange}
            />
          </div>

          <p className="authorize-access_hint">
                  Note: please give an referral user email, 
                  which truelark will use when booking for a new client.
          </p>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBack}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

ZenotiReferral.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBack: () => {},
};

ZenotiReferral.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBack: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
